import Container from '@mui/material/Container';
import React, { FC, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './navigation/Header';
import SideNav from './navigation/SideNav';
import { menuItems } from './navigation/menuitems';

interface LayoutProps {
  children?: React.ReactNode;
}

export const Layout: FC<LayoutProps> = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  return (
    <div id="LayoutDiv">
      <Header onDrawerToggle={handleDrawerToggle} />
      <div style={{ marginTop: '64px', display: 'flex' }}>
        <SideNav
          items={menuItems}
          mobileOpen={mobileOpen}
          onDrawerClose={handleDrawerClose}
          onDrawerTransitionEnd={handleDrawerTransitionEnd}
        />
        <Container maxWidth="lg">{children || <Outlet />}</Container>
      </div>
    </div>
  );
};
